import { MenuItem } from '@mui/material';
import { PayoutStatus } from 'lib/graphql/graphql';
import { FormattedMessage } from 'react-intl';
import { RoundedSelect } from 'styles/styles';

export type PayoutStatusOption = PayoutStatus | 'all';
interface PayoutStatusPickerProps {
  status: PayoutStatusOption
  onChange: (status: PayoutStatusOption) => void
}

function PayoutStatusPicker(props: PayoutStatusPickerProps) {
  const { onChange, status } = props;

  return (
    <RoundedSelect
      value={status}
      onChange={(event) => onChange(event.target.value as PayoutStatusOption)}
    >
      <MenuItem value="all">
        <FormattedMessage id="filter_all_status" />
      </MenuItem>
      {Object.values(PayoutStatus).map((value) => (
        <MenuItem key={value} value={value}>
          <FormattedMessage id={`payout_status_${value}`} />
        </MenuItem>
      ))}
    </RoundedSelect>
  );
}

export default PayoutStatusPicker;
